// extracted by mini-css-extract-plugin
export default {"bgColorWarning":"#ff877f","whiteColor":"#fff","productCard":"ProductCard_productCard__ggVEj","productCard__column":"ProductCard_productCard__column__0r+iW"};